import React, { FC } from 'react';

import { Box, Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';

import { useTranslation } from '../i18n';

const VARIANTS = {
  PROJECTS: 'projects',
  TEMPLATES: 'templates',
} as const;

const ERROR_VARIANTS = {
  EMPTY: 'EMPTY',
  EXISTING: 'EXISTING',
} as const;

const ERROR_KEYS = {
  [VARIANTS.PROJECTS]: {
    [ERROR_VARIANTS.EMPTY]: 'PROJECTS_ERROR_MESSAGE',
    [ERROR_VARIANTS.EXISTING]: 'PROJECTS_LOAD_MORE_ERROR_MESSAGE',
  },
  [VARIANTS.TEMPLATES]: {
    [ERROR_VARIANTS.EMPTY]: 'TEMPLATES_ERROR_MESSAGE',
    [ERROR_VARIANTS.EXISTING]: 'TEMPLATES_LOAD_MORE_ERROR_MESSAGE',
  },
} as const;

type ProjectsErrorProps = {
  variant?: (typeof VARIANTS)[keyof typeof VARIANTS];
  projectsCount?: number;
  retry?: () => void;
};

const ProjectsError: FC<ProjectsErrorProps> = ({
  retry,
  projectsCount = 0,
  variant = VARIANTS.PROJECTS,
}) => {
  const { t } = useTranslation();
  const loadStateKey =
    Number(projectsCount) === 0
      ? ERROR_VARIANTS.EMPTY
      : ERROR_VARIANTS.EXISTING;

  const finalTranslationKey = ERROR_KEYS[variant][loadStateKey];

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      height="64px"
      padding="0 28px 0 27px"
    >
      <AlertWarningIcon
        style={{
          flexShrink: 0,
        }}
      />
      <Box paddingLeft="8px">
        <Text typography="bodySmall" color="charcoal700" paddingRight="5px">
          {t(finalTranslationKey)}
        </Text>
        <LinkButton onClick={retry}>
          <Text typography="bodySmall">{t('TRY_AGAIN')}</Text>
        </LinkButton>
      </Box>
    </Flex>
  );
};

ProjectsError.displayName = 'ProjectsError';

export default Object.assign(ProjectsError, {
  VARIANTS,
});
